import SectionHeader from "../../../util/component/SectionHeader";
import ContentBody from "../common/content-body/ContentBody";
import {useTranslation} from "react-i18next";
import ExpiredPracticesListFilter from "./expired-practices-list-filter/ExpiredPracticesListFilter";
import ExpiredPracticesList from "./expired-practices-list/ExpiredPracticesList";
import Stack from "@mui/material/Stack";

const ExpiredManagementPracticesList = () => {
    const {t} = useTranslation(['expiredManagement']);

    return (
        <>
            <SectionHeader title={t('searchExpired.title')}/>

            <Stack rowGap={3} p={3}>
                <ExpiredPracticesListFilter />
                <ExpiredPracticesList />
            </Stack>
        </>
    )
}

export default ExpiredManagementPracticesList;